import { withStyles } from '@material-ui/core/styles';

const styled = withStyles(theme => {
  return {
    photosContainer: {
      overflow: 'scroll',
      
    },
    userPhoto: {
      height: 300,
      minWidth: 240,
      marginRight: 2,
      backgroundColor: '#ccc',
    },

    photoList: {
      display: 'flex',
      flexDirection: 'row',
      // justifyContent: 'center',
    },
    saveBtn: {
      position: 'fixed',
      bottom: 20,
      right: 20,
    },
    
    saveIcon: {
      marginRight: theme.spacing.unit,
    },
  };
});

export default styled;
